import {Popup} from "../../../models/enums/popup";
import axios from "../../../utilities/axios";

export const seePopupRequest = async (popup: Popup): Promise<void> => {
  try {
    const response = await axios.post<void>(
      `${process.env.REACT_APP_BASE_URL}/users/see-popup`,
      {popUp: popup},
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
